import { mapActions, mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters('modals', {
			getModals: 'getModals',
		}),

		$mx_getModalName() {
			return this.name
		},

		$mx_zindex() {
			const modalId = this.getModals.findIndex(modal => modal.name === this.name)

			if (modalId < 0) return { zIndex: 1000 }

			return { zIndex: 1000 + modalId }
		}
	},
	methods: {
		...mapActions('modals', {
			$mx_setModal: 'setModal',
			$mx_removeModal: 'removeModal',
			$mx_toggleModal: 'toggleModal',
		}),

		$mx_closeModal() {
			this.$root.$emit('modal-close-' + this.$mx_getModalName)
		},

		$mx_reloadTablePage() {
			switch (this.$mx_getModalName) {
				case 'sales-deals-select-broker':
					this.$root.$emit('sales-deals-search')
					break

				case 'sales-proposals-select-broker':
					this.$root.$emit('sales-proposals-search')
					break
			}
		},
	},
}
